<script>
  import { useData } from "$utils/data.svelte.js";
  import { format, scaleOrdinal } from "d3";
  import { Svg, LayerCake, flatten, stack, Html } from "layercake";
  import { AxisX, AxisY } from "@urbaninstitute/dataviz-components";
  import AreaStacked from "./AreaStacked.svelte";
  import { bigDollarFormat, compactLongFormat } from "$utils/formats.js";
  import AreaLine from "./AreaLine.svelte";
  import QuadTree from "./QuadTree.svelte";
  import Tooltip from "./Tooltip.svelte";

  const toolData = useData();
  let data = $derived(toolData.isReady() ? toolData.chartData : []);

  const xKey = "year";
  const yKey = [0, 1];
  const zKey = "key";

  //$inspect(toolData.hoveredProgramVariable);

  //$inspect(toolData.seriesVariables);

  let stackedData = $derived(toolData.isReady() ? stack(data, toolData.seriesVariables) : []);
  //$inspect(stackedData);
</script>

{#if toolData.isReady()}
  <div class="chart-container">
    <LayerCake
      padding={{ top: 50, right: 20, bottom: 20, left: 17 }}
      x={(d) => d.data[xKey]}
      y={yKey}
      z={zKey}
      zScale={scaleOrdinal()}
      zDomain={toolData.seriesVariables}
      zRange={toolData.seriesColors}
      flatData={flatten(stackedData)}
      data={stackedData}
      custom={{
        onhover: (d) => (toolData.hoveredProgramVariable = d ?? null),
        onclick: (d) => (toolData.selectedProgramVariable = d ?? null),
        seriesVariables: toolData.seriesVariables,
        valueFormat: compactLongFormat
      }}
    >
      <Svg>
        <AxisX tickMarks ticks={7} />
        <AxisY formatTick={(d) => bigDollarFormat.format(d)} />
        <g class="chart-area">
          <AreaStacked highlight={toolData.contentBoxProgramVariable} />
          <AreaLine />
        </g>
      </Svg>
      <Html>
        <QuadTree dataset={data} {xKey}>
          {#snippet children(props)}
            {#if props.activeHighlight && props.visible}
              <Tooltip
                x={props.x}
                y={props.y}
                line_y_top={props.line_y_top}
                line_y_bottom={props.line_y_bottom}
                title={props.year}
                description={toolData.getProgramNameFromVariable(props.key)}
                value={props.value}
              />
            {/if}
          {/snippet}
        </QuadTree>
      </Html>
    </LayerCake>
  </div>
{/if}

<style>
  .chart-container {
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 450px;
      margin-left: 20px;
    }
  }
</style>
